// -----------------------------------------------------------------------------
// Force every anchor inside `container` to open in a new tab instead of
// navigating the current frame.
//
// Used for developer/user-authored HTML rendered via dangerouslySetInnerHTML:
// inside the Overwolf app the store runs in a cross-origin iframe whose CSP
// (frame-src) blocks framing third-party sites (e.g. Google Play), so an
// in-frame navigation to an external link is simply blocked. Opening in a new
// tab sidesteps the framing restriction entirely.
// -----------------------------------------------------------------------------
export const openLinksInNewTab = (container: HTMLElement | null): void => {
  if (!container) {
    return;
  }

  container.querySelectorAll('a').forEach((anchor) => {
    anchor.setAttribute('target', '_blank');
    anchor.setAttribute('rel', 'noopener noreferrer');
  });
};
